import Alpine from 'alpinejs'
import mask from '@alpinejs/mask'

import './components/application-form'

Alpine.plugin(mask)
Alpine.start()
